import { DarkModeActionTypes } from "../models";
import { SET_DARK_MODE } from "../types";

// Light until something says otherwise, which is what the server renders for a visitor
// whose request carries no preference.
export default (darkMode = false, action: DarkModeActionTypes): boolean => {
    switch (action.type) {
        case SET_DARK_MODE:
            return action.payload;
        default:
            return darkMode;
    }
};
